export default "__VITE_ASSET__DRuGDcH6__"